import React, { type FC, type PropsWithChildren } from 'react';

import { withImage } from '@lucid/hooks';

import Box from '../../box/box';
import Heading from '../../heading/heading';
import Image from '../../image/image';
import Text from '../../text/text';
import type { StatGridProps } from '../stat-grid';

const SquareCardsStatGrid: FC<PropsWithChildren<StatGridProps>> = ({ items }) => (
  <Box
    css={theme => ({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: theme.space.s24,
      justifyContent: 'center',
      padding: theme.space.s32,
      [theme.breakpoints.bp1024.min]: {
        padding: theme.space.s120,
        paddingBottom: theme.space.s32,
      },
    })}
  >
    {items?.map(statBlock => (
      <Box
        key={`stat-block-${statBlock?.id}`}
        css={theme => ({
          height: '100%',
          width: '100%',
          [theme.breakpoints.bp500.min]: {
            width: '380px',
            height: '380px',
          },
          backgroundColor: theme.colors.white,
          border: `1px solid ${theme.colors.coolGrey[20]}`,
          padding: theme.space.s64,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        })}
      >
        <Image css={theme => ({ maxHeight: theme.space.s64 })} imageSrc={withImage(statBlock?.image)} />
        <Text
          css={theme => ({
            color: theme.colors.indigo[70],
            fontWeight: theme.fontWeights.fw300,
            lineHeight: theme.lineHeights.lh1,
            fontSize: theme.fontSizes.fs64,
            margin: `${theme.space.s16}px 0`,
          })}
        >
          {statBlock?.heading}
        </Text>
        <Heading as="h3" css={theme => ({ fontWeight: theme.fontWeights.fw500 })} variant="headingL">
          {statBlock?.text}
        </Heading>
      </Box>
    ))}
  </Box>
);

export { SquareCardsStatGrid };
export default SquareCardsStatGrid;
